import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/common/ProtectedRoute';
import Navbar from './components/common/Navbar';
import NetworkBanner from './components/common/NetworkBanner';
import AIChatAssistant from './components/common/AIChatAssistant';
import ToastProvider from './components/common/ToastProvider';
import LandingPage from './pages/LandingPage';
import CitizenDashboard from './pages/CitizenDashboard';
import ResponderDashboard from './pages/ResponderDashboard';
import AdminDashboard from './pages/AdminDashboard';
import './i18n';
import './index.css';

function AppShell({ children, showNav = true }) {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  return (
    <div className={darkMode ? 'dark' : ''}>
      <NetworkBanner />
      {showNav && <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />}
      <main>{children}</main>
      <AIChatAssistant />
      <ToastProvider />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Landing */}
          <Route
            path="/"
            element={
              <AppShell showNav={false}>
                <LandingPage />
              </AppShell>
            }
          />

          {/* Citizen */}
          <Route
            path="/citizen"
            element={
              <ProtectedRoute requiredRole="citizen">
                <AppShell>
                  <CitizenDashboard />
                </AppShell>
              </ProtectedRoute>
            }
          />

          {/* Responder */}
          <Route
            path="/responder"
            element={
              <ProtectedRoute requiredRole="responder">
                <AppShell>
                  <ResponderDashboard />
                </AppShell>
              </ProtectedRoute>
            }
          />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AppShell>
                  <AdminDashboard />
                </AppShell>
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
